import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, Column, ConfirmationModal } from 'seagull';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import styles from './CopyAPIKeyModal.module.scss';
const CopyAPIKeyModal = (param)=>{
    let { apiKeyName, apiKeyValue, dismissModal } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "".concat(apiKeyName, " API key"),
        testId: "copy-api-key-modal",
        width: "640px",
        content: /*#__PURE__*/ _jsxs(Column, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(CopyToClipboard, {
                    value: apiKeyValue,
                    testId: "copy-api-key-button",
                    buttonLabel: "Copy"
                }),
                /*#__PURE__*/ _jsx(Callout, {
                    testId: "copy-api-key-callout",
                    children: "Make sure to copy your API key now. You won't be able to see it again."
                })
            ]
        }),
        primaryButtonLabel: "Close",
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal
    });
};
export default CopyAPIKeyModal;
